<template>
    <div class="modal vc_modal my_account_modal" :class="{ 'show': showExplanationModal}">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content my_account_modal_content p_0">
                <button type="button" class="btn-close" @click="closeModal(false)"></button>
                <div class="modal-body p_0">
                    <h5 class="common_subtitle pb_15  font_18p border-lightgray-bottom pt_15 pl_15">{{ selectedNetwork?.public_ip }}</h5>
                    
                    <div class="p_20">
                        <div class="row">
                            <div class="col-12"> 
                                <p>Set explanation for public IP.</p>
                                <div class="mb-3">
                                    <label for="ip_note" class="col-form-label">Explanation</label>
                                    <textarea id="ip_note" class="form-control" rows="5" v-model="form.ip_note"></textarea>
                                    <v-errors :errors="errorFor('ip_note')"></v-errors>
                                </div>
                                <div class="mb-3">
                                    <div class="d_flex_start">
                                        <button
                                            v-if="hasPermission('Explanation')"
                                            type="button"
                                            class="btn btn-primary btn-md  width_100p"
                                            :disabled="lyLoading"
                                            @click.prevent="updateDescription"
                                        >
                                          Update
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {checkPermission} from "@/mixins/permissionsHelper";

export default {
    name: "explanation-modal",
    components: {},
    props: {
        showExplanationModal: {
            type: Boolean,
            required: true
        },
        selectedNetwork: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            form: {
                cloud_network_id: this.selectedNetwork?.id,
                ip_note: this.selectedNetwork?.ip_note,
            }
        }
    },
  computed: {
    ...mapGetters({
      permissions: 'serverPermissions/getServicePermission'
    }),
  },
    created() {
    },
    methods: {
        updateDescription() {
            this.$swal({
                title: 'Would you like to update explanation?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, update it!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    this.axios.post('/update-cloud-network-description',this.form)
                    .then((response) => {
                        if(response.data.success){
                            this.closeModal(true);
                            this.showSuccessMsg(response.data.message);
                        }else{
                            this.$swal({
                                text: response.data.message,
                                showCancelButton: false,
                                confirmButtonText: 'Close!',
                                confirmButtonColor: '#dd4b39',
                                reverseButtons: true
                            })
                        }
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors
                        this.showFailMsg(err.response.data.message);
                    })
                }
            });
        },
        closeModal(value) {
            this.$emit('closeModal', value)
        },
      hasPermission(action) {
        let entity = this.permissions?.cloud_sub_service[2];
        return checkPermission(this.permissions, entity, action);
      },
    }
}
</script>
<style scoped>
    .modal{
        background-color: rgb(0 0 0 / 15%);
    }
</style>
